import { isCollectedFormField } from './is-collected-form-field';

export const filterRequiredFormFields = <T extends { isActive?: boolean; isRequired: boolean }>(fields: T[]) =>
  fields.filter((field) => isCollectedFormField(field) && field.isRequired);
